<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Servizi/Servizi_top.jpg">
<div class="content">
    <h1>Servizi</h1>
</div>
</div>
<!-- <br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a class="active">Riserva naturale Valli Cupe</a></p>
</div>
<br> -->
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Le aree di competenza dell’Agenzia Zampino sono quattro, ovvero: Agenzia Viaggi, Tour operator Incoming, Autonoleggio, Azienda Trasporto persone.
            <br>
            <br>
            Da sempre l’obiettivo primario dell’Agenzia è focalizzato nel soddisfare appieno le esigenze e le richieste del cliente, 
            offrendogli servizi personalizzati e di qualità assoluta. 
            <br>
            <br>
            Un team di professionisti si adopera con passione per curare e pianificare ogni minimo dettaglio del viaggio, 
            organizzando con la massima cura gli spostamenti e la permanenza nella meta prescelta grazie al know-how acquisito nel tempo.
            <br>
            <br>
            L’agenzia si avvale di solide partnership con professionisti del mondo dei viaggi che operano in tutti i settori di mercato, 
            offrendo sempre la migliore qualità al minor prezzo.
            <br>
            <br>
            L’Agenzia Zampino dal 2003 è riconosciuta da MSC Crociere come partner privilegiato nella vendita nel Sud dell’Italia.
            <br>
            <br>
            Tanti sono i servizi che l’Agenzia mette a disposizione dei suoi clienti:
            <br>
            <br>
            •	Organizzazione di viaggi personalizzati;
            <br>
            •	Organizzazione di tour esperienziali, viaggi di gruppo ed escursioni in bici e trekking in Calabria;
            <br>
            •	Organizzazione di soggiorni studio e laboratori didattici;
            <br>
            •	Prenotazione visite guidate con bus, interpreti e guide turistiche;
            <br>
            •	Prenotazione di pacchetti viaggio dei principali tour operator italiani;
            <br>
            •	Crociere;
            <br>
            •	Organizzazione di viaggi di nozze e Liste viaggi;
            <br>
            •	Acquisto di cofanetti regalo;
            <br>
            •	Biglietteria aerea di linea e low cost;
            <br>
            •	Biglietteria ferroviaria (Trenitalia e Italo);
            <br>
            •	Biglietteria navale;
            <br>
            •	Prenotazioni hotel;
            <br>
            •	Acquisto assicurazioni di viaggio;
            <br>
            •	Noleggio auto con conducente;
            <br>
            •	Organizzazione eventi e meeting.

        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<!-- <app-mappe-tematiche></app-mappe-tematiche>
<br>
<br> -->

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>